import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VuereSource from 'vue-resource'
import infiniteScroll from 'vue-infinite-scroll'
import api from './api' // 导入api接口
import { Dropdown, DropdownMenu, DropdownItem, Button, Loading, Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.use(VuereSource);
Vue.use(infiniteScroll);
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 8000 };
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Button);
Vue.use(Loading);
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.$message = Message

api.mainpageApi.getMainPageConfig().then(response => {
    let malMainPageConfig = response.data.data;
    if(malMainPageConfig.redirect && JSON.stringify(malMainPageConfig.redirect) != "{}"){
        window.location.replace(malMainPageConfig.redirect);
    }
    malMainPageConfig.isShowSelf = true;
    store.commit({
        type: 'updateMalMainPageConfig',
        malMainPageConfig: malMainPageConfig
    })
    store.commit({
        type:"updateCacheMap",
        key:malMainPageConfig.showMainPage.showMainPage[0].rank,
        value:JSON.parse(JSON.stringify(malMainPageConfig))//缓存克隆值
      });
    api.mainpageApi.getCartNum().then(response => {
        store.commit({
            type: 'updateCartNum',
            currentNum: response.data.data
        });
    });
    new Vue({
        store,
        render: h => h(App),
    }).$mount('#app');
}).catch((error => {

}));






